export const DEFAULT_PIN_SETTINGS = {
  enabled: false,
  siteId: '',
  brand: '',
  description: '',
  hashtag: '',
  CTA: '',

  language: 'English',
  tone: 'Warm',
  style: 'Descriptive',
  address: 'Directly',
  voice: 'First Person',
  text_length: 50,
  emojies: true,
  hashtags: true,

  board: {
    use_post_category: false,
    use_post_tag: false,
    use_brand_name: true,
    custom_board_name: '',
    cached_boards: []
  },

  publication_time: [
    {
      weekday: 'Saturday',
      time: '09 PM',
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  ],
  recycle_post: false,
  number_of_recycles: 3,

  post_style: 'Carousel',
  eco_mode: true,
  image_ratio: '1:1',
  presets: []
};

export const DEFAULT_INSTA_SETTINGS = {
  enabled: false,
  siteId: '',
  brand: '',
  description: '',
  hashtag: '',
  CTA: '',

  language: 'English',
  tone: 'Warm',
  style: 'Descriptive',
  address: 'Directly',
  voice: 'First Person',
  text_length: 50,
  emojies: true,
  hashtags: true,

  publication_time: [
    {
      weekday: 'Saturday',
      time: '09 PM',
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  ],
  recycle_post: false,
  number_of_recycles: 3,

  post_style: 'Image',
  eco_mode: true,
  image_ratio: '1:1',
  presets: []
};

export const STATUS = {
  QUEUED: 'In Queue',
  PROCESSING: 'Processing',
  DONE: 'Done',
  ERROR: 'Error',
  RETRY: 'Retry',
  SCHEDULED: 'Scheduled'
};
